export const referralBannerText = "<b>Get $1,000 CASH for every company you refer to Hera!</b> Click here to learn more.";